export default [
  {
    id: 'clusters',
    type: 'circle',
    source: 'markers',
    // source: 'clusters',
    paint: {
      'circle-color': '#4A90E2',
      'circle-radius': {
        stops: [
          [1, 0],
          [2, 0],
          [3, 0],
          [4, 0],
          [5, 0],
          [6, 0],
          [7, 0],
          [8, 0],
          [9, 0],
          [10, 0],
          [11, 2.2],
          [12, 2],
          [13, 2.2],
          [14, 2.5],
          [15, 3],
          [16, 3.5],
          [17, 4],
          [18, 4],
          [19, 4],
          [20, 4]
        ]
      },
      'circle-blur': {
        stops: [
          [1, 0],
          [2, 0],
          [3, 0],
          [4, 0],
          [5, 0],
          [6, 0],
          [7, 0],
          [8, 0],
          [9, 0],
          [10, 0],
          [11, 1],
          [12, 0.6],
          [13, 0],
          [14, 0],
          [15, 0],
          [16, 0],
          [17, 0],
          [18, 0],
          [19, 0],
          [20, 0]
        ]
      },
      'circle-opacity': {
        stops: [
        [1, 0],
        [2, 0],
        [3, 0],
        [4, 0],
        [5, 0],
        [6, 0],
        [7, 0],
        [8, 0],
        [9, 0],
        [10, 0],
        [11, 0.65],
        [12, 0.8],
        [13, 1],
        [14, 1],
        [15, 1],
        [16, 1],
        [17, 1],
        [18, 1],
        [19, 1],
        [20, 1]
        ]
      }
    }
  },
  {
    id: 'blueMarkers',
    type: 'circle',
    source: 'markers',
    // source: 'clusters',
    paint: {
      'circle-color': '#33BDFF',
      'circle-radius': {
        stops: [
          [9, 0],
          [10, 9],
          [11, 9],
          [12, 8],
          [13, 5],
          [14, 0]
        ]
      },
      'circle-blur': {
        stops: [
          [9, 1],
          [10, 1],
          [11, 1],
          [12, 1.2],
          [13, 1.2],
          [14, 0]
        ]
      },
      'circle-opacity': {
        stops: [
          [9, 0],
          [10, 0.3],
          [11, 0.45],
          [12, 0.5],
          [13, 0.2],
          [14, 0]
        ]
      }
    }
  },
  {
    id: 'areaMarkers',
    type: 'circle',
    source: 'markers',
    paint: {
      'circle-color': '#00DBFF',
      'circle-radius': {
        stops: [
          [1, 13],
          [2, 11],
          [3, 10],
          [4, 10],
          [5, 9],
          [6, 8.5],
          [7, 9],
          [8, 11],
          [9, 10],
          [10, 9],
          [11, 4]
        ]
      },
      'circle-blur': {
        stops: [
          [1, 3.5],
          [2, 3.1],
          [3, 2.7],
          [4, 2.7],
          [5, 2.4],
          [6, 1.9],
          [7, 1.6],
          [8, 1.6],
          [9, 1.3],
          [10, 1],
          [11, 1]
        ]
      },
      'circle-opacity': {
        stops: [
          [1, 0.7],
          [2, 0.65],
          [3, 0.5],
          [4, 0.50],
          [5, 0.55],
          [6, 0.55],
          [7, 0.7],
          [8, 0.8],
          [9, 0.6],
          [10, 0.4],
          [11, 0.1]
        ]
      }
    }
  },
  {
    id: 'whiteMarkers',
    type: 'circle',
    source: 'markers',
    paint: {
      'circle-color': '#fff',
      'circle-radius': {
        stops: [
          [1, 6.7],
          [2, 5.7],
          [3, 4.7],
          [4, 4.7],
          [5, 2],
          [6, 2.5],
          [7, 4.5],
          [8, 5],
          [9, 4],
          [10, 3],
          [11, 2],
          [12, 0],
          [13, 0],
          [14, 0],
          [15, 0],
          [16, 0],
          [17, 0],
          [18, 0],
          [19, 0],
          [20, 0]
        ]
      },
      'circle-blur': {
        stops: [
          [1, 3.2],
          [2, 3],
          [3, 2.5],
          [4, 2.7],
          [5, 1.2],
          [6, 1.2],
          [7, 2],
          [8, 1.7],
          [9, 1.2],
          [10, 1],
          [11, 1],
          [12, 0],
          [13, 0],
          [14, 0],
          [15, 0],
          [16, 0],
          [17, 0],
          [18, 0],
          [19, 0],
          [20, 0]
        ]
      },
      'circle-opacity': {
        stops: [
          [1, 0.25],
          [2, 0.21],
          [3, 0.21],
          [4, 0.15],
          [5, 0.17],
          [6, 0.25],
          [7, 0.4],
          [8, 0.4],
          [9, 0.4],
          [10, 0.4],
          [11, 0.2],
          [12, 0],
          [13, 0],
          [14, 0],
          [15, 0],
          [16, 0],
          [17, 0],
          [18, 0],
          [19, 0],
          [20, 0]
        ]
      }
    }
  },
  {
    id: 'white_2_Markers',
    type: 'circle',
    source: 'markers',
    paint: {
      'circle-color': '#fff',
      'circle-radius': {
        stops: [
          [1, 1.5],
          [2, 1.4],
          [3, 1.4],
          [4, 1.45],
          [5, 1.4],
          [6, 1.1],
          [7, 1.7],
          [8, 2.1],
          [9, 1.5]
         ]
      },
      'circle-blur': {
        stops: [
          [1, 0.08],
          [2, 0.08],
          [3, 0.08],
          [4, 0.1],
          [5, 0.1],
          [6, 0.1],
          [7, 0.2],
          [8, 0.25],
          [9, 0.8]
         ]
      },
      'circle-opacity': {
        stops: [
          [1, 0.5],
          [2, 0.45],
          [3, 0.37],
          [4, 0.35],
          [5, 0.35],
          [6, 0.4],
          [7, 0.35],
          [8, 0.35],
          [9, 0.1],
         ]
      }
    }
  }
];



/** WEBPACK FOOTER **
 ** ./src/layers.js
 **/